import { Link } from 'react-router';
import PublicLayout from '../components/layout/PublicLayout';

export default function AboutPage() {
  return (
    <PublicLayout showFooterCompanyDetails>
      <div
        className="content-page"
        style={{
          width: '100%',
          boxSizing: 'border-box',
          padding: '56px 24px 80px',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <article
          className="content-card"
          style={{
            width: 'min(820px, 100%)',
            background: 'var(--surface-card)',
            borderRadius: 'var(--radius-lg)',
            boxShadow: 'var(--shadow-card)',
            padding: '56px clamp(24px, 5vw, 60px)',
          }}
        >
          <div
            className="content-copy"
            style={{
              color: 'var(--text-body)',
              fontSize: 16,
              lineHeight: 1.7,
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
            }}
          >
            <h2 style={{ fontSize: 22, margin: '0 0 4px' }}>Hvad er GymGPT?</h2>
            <p style={{ margin: 0 }}>
              GymGPT er en undervisningsplatform henvendt til gymnasiet, der har som målsætning at udnytte det fulde
              potentiale af generativ kunstig intelligens inden for undervisning, læring og dannelse. Det primære fokus
              er at skabe løsninger, der bruger AI som en intelligent tutor for eleverne og dermed hjælpe dem i
              læringsprocessen.
            </p>
            <h2 style={{ fontSize: 22, margin: '32px 0 4px' }}>Hvorfor GymGPT?</h2>
            <p style={{ margin: 0 }}>
              Modsat generelle sprogmodeller henvender GymGPT sig direkte til gymnasiet med læring og udvikling som
              målsætning. GymGPT er instrueret ud fra almindelige pædagogiske principper om at hjælpe den enkelte elev
              med at lære og ikke blot svare på spørgsmål. GymGPT er bygget op omkring en stor databank, der med
              baggrund i de gymnasiale fags læreplaner giver relevante forklaringer, der er i tråd med dem som en
              gymnasielærer ville give. Det er alfa-omega for GymGPT, at de svar som eleverne får er gode og anvendelige
              i forhold til det, de skal bruge i skolen og fremover. Firkantet formuleret er det en bunden opgave, at
              GymGPT vil hjælpe eleverne med at klare sig godt til en eksamen, hvor AI ikke er tilladt.
            </p>
            <h2 style={{ fontSize: 22, margin: '32px 0 4px' }}>Ansvarlig pædagogisk praksis</h2>
            <p style={{ margin: 0 }}>
              Desuden sikrer GymGPT et ansvarligt miljø for læring. Der er indbygget guardrails, der beskytter mod, at
              GymGPT producerer skadeligt indhold, som hvis den bliver spurgt ”Hvad er løsningen til denne opgave?”
              eller ”Hvordan snyder jeg til eksamen?”. GymGPT behandler data ansvarligt og overholder gældende
              lovgivning (som GDPR og AI Act) — se{' '}
              <Link to="/privatlivspolitik">privatlivspolitikken</Link>. Første prioritet for GymGPT er at generere svar
              af høj kvalitet, men vi bestræber os også på at begrænse brugen af ikke europæiske udbydere. Vi benytter
              derfor primært danske Chat.dk og franske Mistral som AI-udbydere.
            </p>
            <h2 style={{ fontSize: 22, margin: '32px 0 4px' }}>Klasseværelset</h2>
            <p style={{ margin: 0 }}>
              Hvis man ønsker at bruge GymGPT i sin daglige undervisning, bør det ske via siden{' '}
              <Link to="/klassevaerelset">Klasseværelset</Link>. I den åbne version af GymGPT er der grænser for, hvor
              mange elever der kan bruge GymGPT samtidigt via samme internetforbindelse (IP-adresse). Dette er ikke et
              problem, hvis eleverne bruger det hjemme. Men på en skole kan denne begrænsning lukke for brugen af GymGPT.
              For at omgå denne begrænsning kan en lærer med en brugerkonto oprette en lærerkode, der giver alle elever i
              en klasse mulighed for at bruge GymGPT samtidig i løbet af timen. Lærere med en konto har desuden mulighed
              for at oprette deres egne chatbots og kan bruge funktioner, der er målrettet forberedelse af lærerens
              undervisning. Ønsker man en lærerkonto kan man{' '}
              <Link to="/ansog-om-adgang">søge om adgang</Link> ved at skrive til os på{' '}
              <a href="mailto:bcp@selvstudier.dk">bcp@selvstudier.dk</a>.
            </p>
            <h2 style={{ fontSize: 22, margin: '32px 0 4px' }}>Hvem står bag GymGPT?</h2>
            <p style={{ margin: 0 }}>
              GymGPT drives af AI-kuja og er stiftet af gymnasielærer og AI-udvikler Bjørn la Cour Poulsen som også står
              bag undervisningsportalen{' '}
              <a href="https://selvstudier.dk" target="_blank" rel="noreferrer">
                selvstudier.dk
              </a>
              . Dermed er der tale om et initiativ som har sine fødder solidt plantet i gymnasiesektoren og kender
              sektorens behov og udfordringer. Hvis man er interesseret i projektet, kan vi altid kontaktes via mail{' '}
              <a href="mailto:bcp@selvstudier.dk">bcp@selvstudier.dk</a> eller telefon{' '}
              <a href="tel:+4571758348">71 75 83 48</a>.
            </p>
          </div>
        </article>
      </div>
    </PublicLayout>
  );
}
